import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@digilize/shared/utils/tokens/src';
import { TranslocoService } from '@ngneat/transloco';
import { Alert, AlertType, ApiError, AppConfig } from '@shared/definitions';
import { first, map, of, Subject, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  alert: Alert;
  alertChange: Subject<Alert> = new Subject<Alert>();

  constructor(private translocoService: TranslocoService, @Inject(APP_CONFIG) private appConfig: AppConfig) {
    this.alertChange.subscribe((alert: Alert) => {
      this.alert = alert;
    });
  }

  setAlert(alert: Alert): void {
    this.alertChange.next(alert);
  }

  setSimpleAlert(type: AlertType, title: string, message: string, translated = false): void {
    const alert = {
      type,
      title: {
        message: title,
        translate: translated,
      },
      message: {
        message: message,
        translate: translated,
      },
    };

    this.alertChange.next(alert);
  }

  handleApiError(apiError: ApiError): void {
    this.translocoService
      .selectTranslate('alert.error.type.' + apiError.type)
      .pipe(
        switchMap((message1) => {
          if (apiError.type === 'validation_error' && apiError.info) {
            return this.translocoService
              .selectTranslate('alert.error.kind.' + apiError.info?.kind)
              .pipe(map((message2) => `${message1} ${message2}`));
          } else {
            return of(message1);
          }
        }),
        first()
      )
      .subscribe((message) => {
        if (apiError) {
          const alert: Alert = {
            type: AlertType.Error,
            title: {
              message: 'Error',
              translate: false,
            },
            message: {
              message: this.getAlertMessage(apiError, message),
              translate: false,
            },
          };
          this.setAlert(alert);
        }
      });
  }

  private getAlertMessage(apiError: ApiError, message: string): string {
    if (apiError.type === 'validation_error' && apiError.info?.field) {
      if (apiError.info.field) {
        message += `<br> [field: ${apiError.info.field}]`;
      }
    }

    if (apiError.request_id) {
      message += `<br> [id: ${apiError.request_id}]`;
    }

    return this.insertMsgParams(message);
  }

  private insertMsgParams(message: string): string {
    return message.replace('{{email}}', this.appConfig.email);
  }
}
